<template>
  <div class="content">
    <div class="title-div">
      <h4>请输入下方的验证码</h4>
      <p class="tips">（tips：验码60秒后失效，请手动点击更新验证码）</p>
    </div>
    <div class="code-div">
      <img
        :src="imageCode"
        alt="验证码"
        class="code-image"
        @click="$emit('change', true)"
      />
      <a-input
        v-model="inputCode"
        class="code-input"
        @pressEnter="$emit('verify', inputCode)"
      />
    </div>
    <div class="btn-row">
      <a-button type="primary" @click="$emit('verify', inputCode)"
        >确定</a-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: "verification-code",
  props: {
    imageCode: {
      type: String,
    },
    downloadUri: {
      type: String,
    },
  },
  data() {
    return {
      inputCode: "",
    };
  },
  created() {},
  methods: {},
  watch: {},
};
</script>
<style scoped>
.content {
  width: 80%;
  margin: 0 auto;
}
.tips {
  font-size: 12px;
  color: #faad14;
  opacity: 0.8;
}
.code-div {
    margin-top: 30px;
}
.code-image {
  margin-right: 30px;
  vertical-align: middle;
  margin-top: -15px;
  cursor: pointer;
}
.code-input {
    margin-top: 20px;
}
.btn-row {
  width: 100%;
  margin-top: 30px;
  text-align: center;
}
</style>